import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { SingleField } from '../fields/SingleField';
import { getOpenFieldsAndSections, toggleOpenFieldSection } from '../store';
import { NettingOtherIssues, UpdatedOpinionField } from '../store/types';
import styles from './OpinionSection.module.scss';
import { SectionWrapper } from './SectionWrapper';

interface NettingOtherIssuesProps {
    otherIssues: NettingOtherIssues;
    previousOtherIssues: NettingOtherIssues | null;
    isEditing: boolean;
    isUpdating: boolean;
    fieldsUpdated: UpdatedOpinionField[];
}

export const NettingOtherIssuesSection: React.FC<NettingOtherIssuesProps> = ({ otherIssues, previousOtherIssues, isEditing, isUpdating, fieldsUpdated }) => {
    const dispatch = useAppDispatch();
    const openFieldsAndSections = useAppSelector(getOpenFieldsAndSections);
    const getFieldOpen = useCallback((id: string) => openFieldsAndSections.includes(id), [openFieldsAndSections]);
    const toggleFieldOpen = useCallback((id: string) => dispatch(toggleOpenFieldSection(id)), [dispatch]);
    const sectionId = 'otherIssues';
    const { otherKeyIssues, internationalOther } = otherIssues;

    const getPreviousField = useCallback((fieldId: keyof NettingOtherIssues) => !isNull(previousOtherIssues) && previousOtherIssues[fieldId] || null, [previousOtherIssues]);

    return (
        <SectionWrapper id={sectionId} label='Other Issues' isEditing={isEditing} isUpdating={isUpdating}>
            <div className={styles.otherIssuesSectionWrapper}>
                <SingleField
                    field={internationalOther}
                    previousField={getPreviousField('internationalOther')}
                    fieldId='internationalOther'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                />
                <SingleField
                    field={otherKeyIssues}
                    previousField={getPreviousField('otherKeyIssues')}
                    fieldId='otherKeyIssues'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                />
            </div>
        </SectionWrapper>
    );
};
